import { UrlObject } from "url";
import { useAmp } from "next/amp";
import React, { FC, ReactElement } from "react";
import { Project } from "~/models/project";
import { Topic } from "~/models/topic";
import LayoutPresenter from "faqSrc/components/layout/Layout/Presenter";

export type LayoutSize = "lg";
interface Props {
  // please specify an asPath for the page using ISR, because router.asPath doesn't work properly in ISR
  // its value is the same as router.asPath
  // asPath is used to generate multi language url in footer
  asPath?: string;
  children: ReactElement;
  hideHeader?: boolean;
  hideFooter?: boolean;
  hideSearch?: boolean;
  languageAlts?: string[];
  layoutSize?: LayoutSize;
  leftSidebar?: React.ReactNode;
  project?: Project;
  mainTitle?: string;
  mainTitleUrl?: UrlObject;
  rightSidebar?: React.ReactNode;
  subTitle?: string;
  subTitleUrl?: UrlObject;
  topic?: Topic;
}

const Layout: FC<Props> = ({
  asPath,
  children,
  hideHeader = false,
  hideFooter = false,
  hideSearch = false,
  languageAlts,
  layoutSize,
  leftSidebar,
  mainTitle,
  mainTitleUrl,
  project,
  rightSidebar,
  subTitle,
  subTitleUrl,
  topic,
}) => {
  const isAmp = useAmp();

  return (
    <LayoutPresenter
      asPath={asPath}
      isAmp={isAmp}
      languageAlts={languageAlts}
      layoutSize={layoutSize}
      leftSidebar={leftSidebar}
      project={project}
      showHeader={!hideHeader}
      showFooter={!hideFooter}
      showSearch={!hideSearch}
      mainTitle={mainTitle}
      mainTitleUrl={mainTitleUrl}
      rightSidebar={rightSidebar}
      subTitle={subTitle}
      subTitleUrl={subTitleUrl}
      topic={topic}
    >
      {children}
    </LayoutPresenter>
  );
};

export default Layout;
